<template>
  <div v-loading="loading" class="cluster">
    <i v-if="cluster.is_locked" class="fa fa-lock cluster__locked"></i>
    <div :class="['cluster__head', { 'bg-white': loading }]">
      <h2 class="cluster__title">
        {{ cluster.name.find(item => item.lang === lang).value }}
      </h2>
    </div>
    <div class="cluster__lesson-list">
      <span
        v-for="lesson in lessons"
        :key="lesson.id"
        :class="['cluster__lesson-link', { 'cluster__lesson-link--disabled': lesson.is_locked }]"
        @click="cluster.is_locked ? null : selectLesson(lesson)"
      >
        <img
          v-if="lesson.state_id === 1"
          src="@/assets/icons/ic_star_border_24px_yellow.svg"
          class="cluster__lesson-icon"
        />
        <img
          v-if="lesson.state_id === 2 && subject.can_make_quiz"
          src="@/assets/icons/ic_star_half_24px.svg"
          class="cluster__lesson-icon"
        />
        <img
          v-if="lesson.state_id === 3 || (lesson.state_id === 2 && !subject.can_make_quiz)"
          src="@/assets/icons/ic_star_24px.svg"
          class="cluster__lesson-icon"
        />
        {{ lesson.name.find(item => item.lang === lang).value }}
      </span>
    </div>
    <template v-if="$route.params.grade_id != 5 && $route.params.grade_id != 2 && subject.can_make_test">
      <router-link
        v-if="progressPercentageCurrentCluster === 100"
        :to="{
          name: 'testInstructions',
          params: { grade_id: $route.params.grade_id, subject_id: $route.params.subject_id, cluster_id: cluster.id },
        }"
        :class="['cluster__test-link', 'cluster__test-link--ready', { 'bg-white': loading }]"
      >
        <i
          class="fa fa-star mr-1"
          :class="progressPercentageCurrentCluster === 100 && cluster.test_performed ? 'yellow' : ''"
        ></i>
        {{ $t('clusterC.takeTest') }}
      </router-link>
      <span v-else :class="['cluster__test-link', { 'bg-white': loading }]">
        <i class="fa fa-star mr-1"></i>
        {{ $t('clusterC.takeTest') }}
      </span>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'ShowCluster',
  props: {
    cluster: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      lessons: [],
      // cluster: {},
      subjectId: this.$route.params.subject_id,
    };
  },
  computed: {
    progressPercentageCurrentCluster: function () {
      let count = 0;
      this.lessons.forEach(lesson => {
        if (lesson.state_id === 3) {
          count++;
        }
      });

      return (count * 100) / this.lessons.length;
    },
    isCurrentCluster: function () {
      return Number.parseInt(this.$route.query.cluster_id) === this.cluster.id;
    },
    ...mapGetters({
      lang: 'app/language',
      subject: 'subject/currentSubject',
    }),
  },
  watch: {
    lessons: {
      // Se usa cuando se crea el componente.
      handler: function (newLessons) {
        newLessons.length && this.isCurrentCluster
          ? this.$store.commit('lesson/FETCH_LIST_SUCCESS', { data: this.lessons })
          : null;
      },
      immediate: true,
    },
    isCurrentCluster: {
      // Se usa cuando el componente es al actual.
      handler: function (newValue) {
        newValue ? this.$store.commit('lesson/FETCH_LIST_SUCCESS', { data: this.lessons }) : null;
      },
      immediate: true,
    },
  },
  async created() {
    // this.onFethtCluster();
    await this.onFetchLessons();
  },
  methods: {
    async selectLesson(lesson) {
      await this.$store.commit('lesson/SET_CURRENT_LESSON', lesson);
      this.$router.push({
        name: 'lesson',
        params: {
          grade_id: this.$route.params.grade_id,
          subject_id: this.$route.params.subject_id,
          lesson_id: lesson.id,
          cluster_id: this.cluster.id,
        },
      });
    },
    onFetchLessons() {
      this.loading = true;
      this.fetchLessons(this.cluster.id)
        .then(res => {
          this.lessons = res.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // onFethtCluster() {
    //   this.fetchCluster({
    //     clusterId: this.clusterId,
    //     subjectId: this.subjectId,
    //   }).then(res => {
    //     this.cluster = { ...res.data };
    //   });
    // },
    ...mapActions({
      fetchLessons: 'lesson/FETCH_LIST',
      // fetchCluster: 'cluster/FETCH_SINGLE',
    }),
  },
};
</script>

<style lang="sass" scoped>
.cluster
  background: #fff
  border-radius: 15px 15px 5px 5px
  box-shadow: 5px 5px 10px rgba($color: #000000, $alpha: 0.4)
  margin-bottom: 1rem
  max-width: 1500px
  margin: auto
  padding-top: 15px
  position: relative
  min-height: 60vh
  width: 92%
  +forTablet
    min-height: 55vh
    width: 85%
  +forDesktop
    min-height: 70vh
    width: 85%
  &:after,
  &:before
    right: 100%
    top: 75px
    +forTablet
      top: 85px
    border: solid transparent
    content: " "
    height: 0
    width: 0
    position: absolute
    pointer-events: none
  &:after
    border-color: rgba(194, 225, 245, 0)
    border-right-color: #76791f
    border-width: 20px
    margin-top: -20px
    z-index: -1
  &:before
    border-color: rgba(194, 225, 245, 0)
    border-right-color: #76791f
    border-width: 20px
    margin-top: -20px
    z-index: -1
  +element('head')
    align-items: center
    background: #ced529
    display: flex
    margin-left: -20px
    width: 95%
    box-shadow: 4px 3px 10px rgba(0,0,0,.75)
    height: 60px
    padding-left: .5em
    +forTablet
      height: 70px
    +forDesktop
      padding-left: 2em
  +element('title')
    color: #fff
    font-family: 'latoregular'
    font-weight: bold
    line-height: 1
    margin-bottom: 0
    font-size: 1.3rem
    +forTablet
      font-size: 1.6rem
  +element('lesson-list')
    overflow-y: auto
    padding: 1em 5px 2em 5px
  +element('lesson-link')
    border-radius: 5px
    color: green
    display: flex
    align-items: center
    font-family: 'varela_roundregular'
    font-size: 1.02rem
    padding: 5px
    text-decoration: none
    transition: background-color 0.02s
    &:hover
      text-decoration: underline
      cursor: pointer
    +forTablet
      font-size: 1.5em
    +modifier('disabled')
      color: #6c757d
      &:hover
        text-decoration: none
        cursor: default
  +element('lesson-icon')
    margin-right: 5px
    height: 25px
    width: 25px
  +element('test-link')
    user-select: none
    align-items: center
    background: #b9b9b9
    box-shadow: 5px 5px 10px rgba($color: #000000, $alpha: 0.4)
    display: flex
    border-radius: 5px
    height: 50px
    color: #fff
    font-family: 'varela_roundregular'
    font-size: 22px
    padding-left: 10px
    text-decoration: none
    width: 180px
    position: absolute
    right: -15px
    bottom: 25px
    +forTablet
      right: -30px
    +modifier('ready')
      background: #089d35
      box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.75)
      transition: transform 0.02s
      &:hover
        transform: scale(1.01)
    +modifier('disabled')
      background: grey
      box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.5)
      pointer-events: none
  +element('locked')
    position: absolute
    font-size: 150px
    opacity: .5
    right: calc( 50% - 75px )
    top: calc( 50% - 75px )
.yellow
  color: #fefd2a
</style>
